import { useState, useEffect } from 'react';
import { Label } from '@fluentui/react';
import { Rating } from '@smastrom/react-rating';
import '@smastrom/react-rating/style.css';

import styles from './FeedbackForm.module.css';

interface Props {
  label: string;
  ratingValue: number;
  onRatingChange: (value: number) => void;
}

export const RatingQuestion = ({ label, ratingValue, onRatingChange }: Props) => {
  const [hoveredRating, setHoveredRating] = useState<number | null>(null);

  const getRatingText = (value: number) => {
    const ratingTexts = ['Poor', 'Fair', 'Good', 'Very Good', 'Excellent'];
    return ratingTexts[value - 1] || '';
  };

  const handleHoverChange = (value: number | null) => {
    setHoveredRating(value === 0 ? null : value);
  };

  const handleRatingChange = (value: number) => {
    onRatingChange(value);
  };

  const displayRating = hoveredRating !== null ? hoveredRating : ratingValue;
  const displayText = displayRating ? getRatingText(displayRating) : '';


  return (
    <div className={styles.ratingQuestionContainer}>
      <Label>{label}</Label>
      <div className={styles.ratingQuestionContent}>
        <Rating
          value={ratingValue}
          onChange={handleRatingChange}
          onHoverChange={handleHoverChange}
          style={{ maxWidth: 180 }}
        />
        {displayText && (
          <span className={styles.ratingTooltip}>
            {displayText}
          </span>
        )}
      </div>
    </div>
  );
};
